import React from "react";
import { compose, withProps } from "recompose";
import classnames from "classnames";

import { Text } from "components/core/Typography";
import { Button } from "components/core/Button";
import { Overlay } from "components/core/GoogleMap";

const formatPriceLabel = (lowestPrice) => {
	if (typeof lowestPrice === "number" && !Number.isNaN(lowestPrice)) {
		return `$${Math.floor(lowestPrice)}`;
	}

	if (
		typeof lowestPrice === "string" &&
		lowestPrice.trim() !== "" &&
		!Number.isNaN(parseFloat(lowestPrice.replace(/,/g, "")))
	) {
		return `$${Math.floor(parseFloat(lowestPrice.replace(/,/g, "")))}`;
	}

	return "";
};

export const enhance = compose(
	withProps(({ facility, onClick, onMouseEnter, onMouseLeave, selected }) => ({
		className: classnames("search-facility-marker", { selected }),
		location: facility.location,
		label: (
			<Button
				className="facility-marker-button"
				onClick={onClick}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				label={`Select ${facility?.name || "facility"} on map`}
				fullWidth={false}
			>
				<Text
					className="facility-marker-label"
					size="small"
					color="blue"
					weight="extraBold"
					last
				>
					{formatPriceLabel(
						facility?.lowestPrice ?? facility?.startingPrice
					)}
				</Text>
			</Button>
		)
	}))
);

export default enhance(Overlay);
